import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../constants/ActionNameConstants';
import { VENDOR_DETAIL_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { vendorDetailsFailure, vendorDetailsSuccess } from '../actions';

const VendorDetailsAPI = (action) => postApiRequest(VENDOR_DETAIL_API_URL, action);

function* handleVendorDetails(action) {
  try {
    const response = yield call(VendorDetailsAPI, action.payload);
    yield put(vendorDetailsSuccess(response));
  } catch (error) {
    yield put(vendorDetailsFailure(error));
  }
}

export function* watchVendorDetails() {
  yield takeLatest(types.VENDOR_DETAILS_REQUEST, handleVendorDetails);
}
